<script setup lang="ts">
import {
  UIModal,
  UIModalContent,
  UIModalFooter,
  UIModalHeader,
} from '@gohighlevel/ghl-ui'
import { AlertCircleIcon } from '@gohighlevel/ghl-icons/24/outline'

const props = defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  (e: 'update:show', value: boolean): void
  (e: 'onCancel'): void
  (e: 'onOk'): void
}>()

const handleCancel = () => {
  emit('onCancel')
  emit('update:show', false)
}

const handleOk = () => {
  emit('onOk')
  emit('update:show', false)
}
</script>

<template>
  <UIModal
    :show="props.show"
    @update:show="val => emit('update:show', val)"
    id="unsaved-changes-modal"
    type="error"
  >
    <template #header>
      <UIModalHeader
        id="unsaved-changes-header"
        :title="$t('common.unsavedChangesTitle')"
        type="error"
        :icon="AlertCircleIcon"
        @close="handleCancel"
      />
    </template>
    <UIModalContent class="pt-0">
      <p>
        {{ $t('common.unsavedChanges') }}
      </p>
    </UIModalContent>
    <template #footer>
      <UIModalFooter
        id="unsaved-changes-footer"
        type="error"
        :negativeText="$t('common.cancel')"
        :positiveText="$t('common.ok')"
        @negativeClick="handleCancel"
        @positiveClick="handleOk"
      />
    </template>
  </UIModal>
</template>
